(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["owl-delivery-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shopify Forms currently omits the textarea ID used by its visible label.
    const fieldName = 'custom#wines_and_quantities_include_vintage_and_bottle_size';
    const observed = new WeakSet();
    const repair = (root) => {
      const field = root.querySelector('textarea[name="' + fieldName + '"]');
      const label = Array.from(root.querySelectorAll('label')).find(
        (candidate) => candidate.htmlFor === fieldName
      );
      if (field && label && !field.id) field.id = fieldName;
    };
    const connect = () => {
      document.querySelectorAll('shopify-forms-embed').forEach((host) => {
        const root = host.shadowRoot;
        if (!root) return;
        repair(root);
        if (observed.has(root)) return;
        observed.add(root);
        new MutationObserver(() => repair(root)).observe(root, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'for']
        });
      });
    };
    connect();
    // Allow the app's custom element and shadow root to mount asynchronously.
    const timer = setInterval(connect, 500);
    setTimeout(() => clearInterval(timer), 60000);
    document.addEventListener('shopify:section:load', connect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owl-header"]) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest('.owl-site-header');
    if (!header) return;
    const branch = event.target.closest('details[open]');
    if (branch) {
      branch.open = false;
      branch.querySelector('summary')?.focus();
      event.preventDefault();
    }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.owl-site-header').forEach((header) => {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owl-main-cart"]) return;
  try {
    
  (() => {
    const selector = '.owl-cart__form input[name="updates[]"]';
    const validate = (input) => {
      const value = input.valueAsNumber;
      input.setCustomValidity(value > 0 && value < Number(input.dataset.minimum) ? input.dataset.minimumError : '');
    };
    document.querySelectorAll(selector).forEach(validate);
    const resetConfirmations = form => {
      form.querySelectorAll('input[type="checkbox"][name^="attributes["]').forEach(input => { input.checked = false; });
      form.dispatchEvent(new CustomEvent('owl:parcel-changed'));
    };
    document.addEventListener('input', (event) => {
      if (event.target.matches(selector)) {
        validate(event.target);
        resetConfirmations(event.target.closest('form'));
      }
    });
    document.addEventListener('submit', event => {
      if (event.target.matches('.owl-cart__form') && event.submitter?.name === 'update') resetConfirmations(event.target);
    });
    // Explicit empty values remove previously saved confirmations on cart updates.
    document.addEventListener('formdata', event => {
      if (!event.target.matches('.owl-cart__form')) return;
      event.target.querySelectorAll('input[type="checkbox"][name^="attributes["]').forEach(input => {
        event.formData.set(input.name, input.checked ? input.value : '');
      });
    });
    document.addEventListener('shopify:section:load', () => document.querySelectorAll(selector).forEach(validate));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owl-main-product"]) return;
  try {
    
  document.addEventListener('change', event => {
    const picker = event.target.closest('.owl-product__variant-picker');
    if (!picker) return;
    const purchaseForm = picker.parentElement.querySelector('.owl-product__form');
    purchaseForm?.querySelectorAll('button, input').forEach(input => { input.disabled = true; });
    picker.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owl-private-cellar-product"]) return;
  try {
    
  document.addEventListener('change', event => {
    const picker = event.target.closest('.owl-private-cellar__picker');
    if (!picker) return;
    picker.parentElement.querySelector('.owl-private-cellar__purchase')?.querySelectorAll('input, button').forEach(control => { control.disabled = true; });
    picker.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();
})();
